export default "__VITE_ASSET__D6MIr42H__"